import React from 'react';

function Footer(props) {
    return (
        <footer>
            <div className="body-container">
                <ul className="disclaimers">
                    <li>
                        <p>©2024 | Teacher2Teacher</p>
                    </li>
                    <li>
                        <a href="https://share.teacher2teacher.education/privacy">Privacy Policy</a>
                    </li>
                </ul>
            </div>
        </footer>
    );
}

export default Footer;
